/* eslint-disable */
import React, { PropTypes } from 'react';
import _ from 'lodash';
import $ from 'jquery';
import { Modal, Button, Col, Row, Well, HelpBlock } from 'react-bootstrap';
import { TextField, ReadOnlyField } from './AdminComponents';
import { browserHistory } from 'react-router';
import Select from 'react-select';
import Dropzone from 'react-dropzone';

export default class AdminManageAccountCt extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			is_loaded: false,
			enableEdit: props.route.type === 'add' ? true : false,
			showErrorMsg: false,
			upload_img: [],
			img: '',
			email: '',
			ext: '',
			fax: '',
			tel: '',
			is_admin: '0',
			is_display: '1',
			agent_id: '0',
			job_title: '',
			user_name: '',
			user_passwd: '',
			check_passwd: '',
			user_account: '',
			mobile_phone: '',
			mobile_phone2: '',
			lang_guid: '',
			role_id: '',
			role_option: {},
			is_merge_role_option: false,
			role_data: [],
			is_merge_role_data: false,
			group_id: '',
			group_option: {},
			is_merge_group_option: false,
			usergroup_data: [],
			is_merge_usergroup_data: false,
		}

		this.onDrop = this.onDrop.bind(this)
	}

	componentDidMount() {

		const { params, route } = this.props

		route.type === 'edit' ? this.loadData(params.email) : this.onMerge()
	}

	componentWillReceiveProps(nextProps) {

	}

	componentDidUpdate() {

		const { is_loaded_role_data, is_loaded_usergroup_data } = this.props
		const { is_loaded, is_merge_role_data, is_merge_usergroup_data, role_data, usergroup_data, role_id, group_id, is_merge_role_option, is_merge_group_option } = this.state

		//	簡易判斷
		if (!is_merge_role_data && !is_merge_usergroup_data && is_loaded_role_data && is_loaded_usergroup_data) {

			this.onMerge()
		}

		//  合併id成option
		if (is_loaded && is_merge_role_data && is_loaded_usergroup_data && !is_merge_role_option && !is_merge_group_option) {

			let role_option = _.find(role_data, { value: role_id })
			role_option = role_option === undefined ? {} : role_option

			let group_option = _.find(usergroup_data, { value: group_id })
			group_option = group_option === undefined ? {} : group_option

			this.setState({ role_option: role_option, group_option: group_option, is_merge_role_option: true, is_merge_role_option: true })
		}
	}

	loadData(email) {

		$.ajax({
			type: 'get',
			url: '/api/W_ManageAccount_Get.php?user_account=' + email,
			success: response => {
				if (response.status === '0') {

					this.setState({
						img: response.result[0].img_path,
						email: response.result[0].email,
						ext: response.result[0].ext,
						fax: response.result[0].fax,
						tel: response.result[0].tel,
						is_admin: response.result[0].is_admin,
						is_display: response.result[0].is_display,
						agent_id: response.result[0].agent_id,
						job_title: response.result[0].job_title,
						user_name: response.result[0].user_name,
						user_account: response.result[0].user_account,
						mobile_phone: response.result[0].mobile_phone,
						mobile_phone2: response.result[0].mobile_phone2,
						role_id: response.result[0].role_id,
						group_id: response.result[0].user_group,
						is_loaded: true
					})
				}
				else alert(response.msg)
			},
			error: (xhr, ajaxOptions, thrownError) => { },
		});
	}

	onMerge() {

		const { is_loaded_role_data, role_data, is_loaded_usergroup_data, usergroup_data } = this.props
		const { is_merge_role_data, is_merge_usergroup_data } = this.state

		if (is_loaded_role_data == true && is_merge_role_data == false) {

			let merge_data = role_data.map((x, y) => {
				x.label = x.role_name
				x.value = x.sub_role
				return x
			})
			this.setState({ role_data: merge_data, is_merge_role_data: true })
		}

		if (is_loaded_usergroup_data == true && is_merge_usergroup_data == false) {

			let merge_data = usergroup_data.map((x, y) => {
				x.label = x.name
				x.value = x.id
				return x
			})
			this.setState({ usergroup_data: merge_data, is_merge_usergroup_data: true })
		}
	}

	onDrop(acceptedFiles) {

		if (acceptedFiles.length > 1) {

			alert('請上傳單一檔案')
			return false
		}

		this.setState({ upload_img: acceptedFiles });
	}

	onSubmit() {

		const { route } = this.props
		const {
			upload_img,
			img,
			user_account,
			user_passwd,
			check_passwd,
			user_name,
			group_option,
			role_option,
			job_title,
			mobile_phone,
			mobile_phone2,
			email,
			tel,
			ext,
			fax,
			agent_id,
			is_admin,
			is_display
		} = this.state


		if (
			( // 新增
				route.type === 'add' &&
				upload_img.length === 0 &&
				user_account === '' &&
				user_passwd === '' &&
				check_passwd === ''
				&& (user_passwd.length < 6 || user_passwd !== check_passwd || !this.isEmail(user_account))
			) || ( // 修改
				user_name === '' &&
				email === '' &&
				JSON.stringify(group_option) === '{}' &&
				JSON.stringify(role_option) === '{}'
				// job_title === '' &&
				// mobile_phone === '' &&
				// mobile_phone2 === '' &&
				// tel === '' &&
				// ext === '' &&
				// fax === '' 
				|| !this.isEmail(email)
			)
		) {
			this.setState({ showErrorMsg: true })
		}
		else {
			let formData = new FormData()
			formData.append('user_account', user_account)
			formData.append('user_passwd', user_passwd)
			formData.append('check_passwd', check_passwd)
			formData.append('user_name', user_name)
			formData.append('email', email)
			formData.append('job_title', job_title)
			formData.append('group_id', group_option.value)
			formData.append('role_id', role_option.value)
			formData.append('mobile_phone', mobile_phone)
			formData.append('mobile_phone2', mobile_phone2)
			formData.append('tel', tel)
			formData.append('ext', ext)
			formData.append('fax', fax)
			formData.append('agent_id', agent_id)
			formData.append('is_admin', is_admin)
			formData.append('is_display', is_display)
			formData.append('emp_id', '000001')	// 作用不明
			formData.append('lang_guid', 'zh-tw')
			formData.append('role_list', '0') // 作用不明
			// formData.append( 'is_fix_user', '0' ) 
			// formData.append( 'disabled', '0' ) 

			$.ajax({
				type: 'post',
				url: route.type === 'add' ? '/api/W_ManageAccount_Post.php' : '/api/W_ManageAccount_Update.php',
				data: formData,
				processData: false,
				contentType: false,
				success: response => {
					if (response.status === '0') {//成功

						this.setState({ enableEdit: false })
						this.uploadFile(response.result[0].user_account)
						this.props.reloadData()
						// browserHistory.push('/salesky/admin/ManageAccount/' + response.result.id );
					}
					else { alert(response.msg) }
				},
				error: error => { },
			});
		}
	}

	onRemove() {
		if (confirm('確定刪除嗎?')) {

			const { user_account } = this.state

			let formData = new FormData()
			formData.append('user_account', user_account)

			$.ajax({
				type: 'post',
				url: '/api/W_ManageAccount_Delete.php',
				data: formData,
				processData: false,
				contentType: false,
				success: response => {
					if (response.status === '0') {//成功

						this.props.closeModal()
						this.props.reloadData()
					}
					else { alert(response.msg) }
				},
				error: error => { },
			});
		}
	}

	uploadFile(user_account) {

		const { upload_img } = this.state

		if (upload_img.length > 0) {

			let formData = new FormData();
			formData.append('user_account', user_account);
			formData.append('file', upload_img[0]);
			formData.append('type', 'UserProfile');

			$.ajax({
				async: false,
				type: 'post',
				url: '/api/W_SaleSky_FileUpload_Post.php',
				data: formData,
				processData: false,
				contentType: false,
				success: response => { response.status === '0' ? '' : alert(response.msg) },
				error: error => { },
			});
		}
	}

	isEmail(email) {

		var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
		return re.test(email);
	}

	renderBtns() {

		const { closeModal, params, route } = this.props
		const { enableEdit } = this.state

		let remove_btn = (route.type === 'edit' && enableEdit === true) ? <Button onClick={() => this.onRemove()}>刪除</Button> : null
		let edit_btn = enableEdit === true ? <Button onClick={() => this.onSubmit()}>儲存</Button> : <Button onClick={() => this.setState({ enableEdit: true })}>編輯</Button>

		if (params.id !== '1') {

			return (
				<div>
					{remove_btn}
					{edit_btn}
					<Button onClick={closeModal}>關閉</Button>
				</div>
			)
		}
		else {

			return <Button onClick={closeModal}>關閉</Button>
		}
	}

	render() {

		const { route, closeModal } = this.props;
		const {
			enableEdit,
			showErrorMsg,
			img,
			upload_img,
			user_account,
			user_passwd,
			user_name,
			check_passwd,
			email,
			job_title,
			mobile_phone,
			mobile_phone2,
			fax,
			tel,
			ext,
			agent_id,
			is_admin,
			is_display,
			role_data,
			role_option,
			usergroup_data,
			group_option,
			passwdErrorMsg
		} = this.state

		// let title = '新角色名稱'
		// if ( route.type === 'edit' ) {
		//   title = enableEdit === false ? '檢視角色名稱' : '編輯角色名稱'
		// }
		let d = new Date().getTime()
		let pro_pic = img === '' ? '/imgs/default-profile.png' : img

		return (
			<div>
				<Modal
					show={true}
					bsSize="large"
					className="div-newsCt"
					keyboard={false}
					backdrop="static"
					id="admin"
				// onHide={closeModal}
				>
					<Modal.Header>
						<Modal.Title>帳戶管理 {route.type === 'add' ? null : " - " + user_account}</Modal.Title>
						<span className="span-newsModalBtn">
							{this.renderBtns()}
						</span>
					</Modal.Header>
					<Modal.Body>
						<Row>
							<Col sm={12}>
								<div style={{ fontWeight: "bold" }}><span style={{ color: "red" }}>* </span>圖片</div>
							</Col>
						</Row>
						<Row>
							<Col sm={12}>
								<Col sm={4} style={{ padding: '4px 0' }}>
									<div>
										{
											upload_img.length === 0
												? <img className="preview_img" src={pro_pic + "?v=" + d} />
												: upload_img.map((x, y) => <img key={y} className="preview_img" src={x.preview} />)
										}
									</div>
									{showErrorMsg && upload_img.length === 0 && img === '' ? <HelpBlock>內容請勿空白</HelpBlock> : null}
								</Col>
								<Col sm={8}>
									<Dropzone onDrop={this.onDrop} ref={(node) => this.dropzoneRef = node} accept=".jpg,.jpeg,.png" style={{ display: 'none' }}></Dropzone>
									<button disabled={!enableEdit} className="btn btn-primary" onClick={() => this.dropzoneRef.open()}>上傳檔案</button>
								</Col>
							</Col>
						</Row>
						{
							route.type === 'add' ?
								<div>
									<Row>
										<Col sm={12}>
											<div style={{ fontWeight: "bold" }}><span style={{ color: "red", display: route.type === 'add' ? 'inline-block' : 'none' }}>* </span>使用者帳戶</div>
										</Col>
									</Row>
									<Row>
										<Col sm={12}>
											<input className="form-control" disabled={!enableEdit} value={user_account} onChange={(e) => this.setState({ user_account: e.target.value })} />
											{showErrorMsg && user_account === '' ? <HelpBlock>內容請勿空白</HelpBlock> : null}
											{showErrorMsg && !this.isEmail(user_account) ? <HelpBlock>信箱格式錯誤</HelpBlock> : null}
										</Col>
									</Row>
								</div> : null
						}
						<Row>
							<Col sm={12}>
								<div style={{ fontWeight: "bold" }}><span style={{ color: "red" }}>* </span>使用者名稱</div>
							</Col>
						</Row>
						<Row>
							<Col sm={12}>
								<input className="form-control" disabled={!enableEdit} value={user_name} onChange={(e) => this.setState({ user_name: e.target.value })} />
								{showErrorMsg && user_name === '' ? <HelpBlock>內容請勿空白</HelpBlock> : null}
							</Col>
						</Row>
						<Row>
							<Col sm={12}>
								<div style={{ fontWeight: "bold" }}><span style={{ color: "red", display: route.type === 'add' ? 'inline-block' : 'none' }}>* </span>密碼</div>
							</Col>
						</Row>
						<Row>
							<Col sm={12}>
								<input type="password" className="form-control" disabled={!enableEdit} value={user_passwd} onChange={(e) => this.setState({ user_passwd: e.target.value })} />
								{showErrorMsg && user_passwd === '' && route.type === 'add' ? <HelpBlock>內容請勿空白</HelpBlock> : null}
								{showErrorMsg && user_passwd.length < 6 && route.type === 'add' ? <HelpBlock>密碼不得小於6個字元</HelpBlock> : null}
							</Col>
						</Row>
						<Row>
							<Col sm={12}>
								<div style={{ fontWeight: "bold" }}><span style={{ color: "red", display: route.type === 'add' ? 'inline-block' : 'none' }}>* </span>確認密碼</div>
							</Col>
						</Row>
						<Row>
							<Col sm={12}>
								<input type="password" className="form-control" disabled={!enableEdit} value={check_passwd} onChange={(e) => this.setState({ check_passwd: e.target.value })} />
								{user_passwd !== check_passwd ? <HelpBlock>密碼不一致</HelpBlock> : null}
							</Col>
						</Row>
						<Row>
							<Col sm={12}>
								<div style={{ fontWeight: "bold" }}><span style={{ color: "red" }}>* </span>email</div>
							</Col>
						</Row>
						<Row>
							<Col sm={12}>
								<input className="form-control" disabled={!enableEdit} value={email} onChange={(e) => this.setState({ email: e.target.value })} />
								{showErrorMsg && email === '' ? <HelpBlock>內容請勿空白</HelpBlock> : null}
								{showErrorMsg && !this.isEmail(email) ? <HelpBlock>信箱格式錯誤</HelpBlock> : null}
							</Col>
						</Row>
						<Row>
							<Col sm={12}>
								<div style={{ fontWeight: "bold" }}><span style={{ color: "red" }}>* </span>群組</div>
							</Col>
						</Row>
						<Row>
							<Col sm={12}>
								<Select
									disabled={!enableEdit}
									options={usergroup_data}
									onChange={(option) => this.setState({ group_option: option })}
									value={group_option}
								/>
								{showErrorMsg && JSON.stringify(group_option) === '{}' ? <HelpBlock>內容請勿空白</HelpBlock> : null}
							</Col>
						</Row>
						<Row>
							<Col sm={12}>
								<div style={{ fontWeight: "bold" }}><span style={{ color: "red" }}>* </span>角色</div>
							</Col>
						</Row>
						<Row>
							<Col sm={12}>
								<Select
									disabled={!enableEdit}
									options={role_data}
									onChange={(option) => this.setState({ role_option: option })}
									value={role_option}
								/>
								{showErrorMsg && JSON.stringify(role_option) === '{}' ? <HelpBlock>內容請勿空白</HelpBlock> : null}
							</Col>
						</Row>
						{
							/*
							<Row>
								<Col sm={12}>
									<div style={{fontWeight: "bold"}}><span style={{color: "red"}}>* </span>emp_id</div>
								</Col>
							</Row>
							<Row>
								<Col sm={12}>
									<input className="form-control" disabled={ !enableEdit } />
								</Col>
							</Row>
							<Row>
								<Col sm={12}>
									<div style={{fontWeight: "bold"}}><span style={{color: "red"}}>* </span>lang_guid</div>
								</Col>
							</Row>
							<Row>
								<Col sm={12}>
									<input className="form-control" disabled={ !enableEdit } />
								</Col>
							</Row>
							*/
						}
						<Row>
							<Col sm={12}>
								<div style={{ fontWeight: "bold" }}>職稱</div>
							</Col>
						</Row>
						<Row>
							<Col sm={12}>
								<input className="form-control" disabled={!enableEdit} value={job_title} onChange={(e) => this.setState({ job_title: e.target.value })} />
								{ /*showErrorMsg && job_title === '' ? <HelpBlock>內容請勿空白</HelpBlock> : null*/}
							</Col>
						</Row>
						<Row>
							<Col sm={12}>
								<Row>
									<Col sm={6}>
										<div style={{ fontWeight: "bold" }}>手機號碼1</div>
									</Col>
									<Col sm={6}>
										<div style={{ fontWeight: "bold" }}>手機號碼2</div>
									</Col>
								</Row>
							</Col>
						</Row>
						<Row>
							<Col sm={12}>
								<Row>
									<Col sm={6}>
										<input className="form-control" disabled={!enableEdit} value={mobile_phone} onChange={(e) => this.setState({ mobile_phone: e.target.value })} />
										{ /*showErrorMsg && mobile_phone === '' ? <HelpBlock>內容請勿空白</HelpBlock> : null*/}
									</Col>
									<Col sm={6}>
										<input className="form-control" disabled={!enableEdit} value={mobile_phone2} onChange={(e) => this.setState({ mobile_phone2: e.target.value })} />
										{ /*showErrorMsg && mobile_phone2 === '' ? <HelpBlock>內容請勿空白</HelpBlock> : null*/}
									</Col>
								</Row>
							</Col>
						</Row>
						<Row>
							<Col sm={12}>
								<Row>
									<Col sm={6}>
										<div style={{ fontWeight: "bold" }}>電話</div>
									</Col>
									<Col sm={6}>
										<div style={{ fontWeight: "bold" }}>分機</div>
									</Col>
								</Row>
							</Col>
						</Row>
						<Row>
							<Col sm={12}>
								<Row>
									<Col sm={6}>
										<input className="form-control" disabled={!enableEdit} value={tel} onChange={(e) => this.setState({ tel: e.target.value })} />
										{ /*showErrorMsg && tel === '' ? <HelpBlock>內容請勿空白</HelpBlock> : null*/}
									</Col>
									<Col sm={6}>
										<input className="form-control" disabled={!enableEdit} value={ext} onChange={(e) => this.setState({ ext: e.target.value })} />
										{ /*showErrorMsg && ext === '' ? <HelpBlock>內容請勿空白</HelpBlock> : null*/}
									</Col>
								</Row>
							</Col>
						</Row>
						<Row>
							<Col sm={12}>
								<Row>
									<Col sm={6}>
										<div style={{ fontWeight: "bold" }}>傳真</div>
									</Col>
									<Col sm={6}>
										<div style={{ fontWeight: "bold" }}>代理商</div>
									</Col>
								</Row>
							</Col>
						</Row>
						<Row>
							<Col sm={12}>
								<Row>
									<Col sm={6}>
										<input className="form-control" disabled={!enableEdit} value={fax} onChange={(e) => this.setState({ fax: e.target.value })} />
									</Col>
									<Col sm={6}>
										<select className="form-control" disabled={!enableEdit} value={agent_id} onChange={(e) => this.setState({ agent_id: e.target.value })}>
											<option value="1">是</option>
											<option value="0">否</option>
										</select>
									</Col>
								</Row>
							</Col>
						</Row>
						<Row>
							<Col sm={12}>
								<Row>
									<Col sm={6}>
										<div style={{ fontWeight: "bold" }}>系統管理者</div>
									</Col>
									<Col sm={6}>
										<div style={{ fontWeight: "bold" }}>使用者清單顯示</div>
									</Col>
								</Row>
							</Col>
						</Row>
						<Row>
							<Col sm={12}>
								<Row>
									<Col sm={6}>
										<select className="form-control" disabled={!enableEdit} value={is_admin} onChange={(e) => this.setState({ is_admin: e.target.value })}>
											<option value="1">是</option>
											<option value="0">否</option>
										</select>

									</Col>
									<Col sm={6}>
										<select className="form-control" disabled={!enableEdit} value={is_display} onChange={(e) => this.setState({ is_display: e.target.value })}>
											<option value="1">是</option>
											<option value="0">否</option>
										</select>

									</Col>
								</Row>
							</Col>
						</Row>
					</Modal.Body>
					<Modal.Footer>
						{this.renderBtns()}
					</Modal.Footer>
				</Modal>
			</div>
		);
	}
}

AdminManageAccountCt.prototypes = {
	closeModal: PropTypes.func.isRequired,
}





// WEBPACK FOOTER //
// ./src/salesky/routes/admin/AdminManageAccountCt.jsx